export default __webpack_public_path__ + "static/media/Illustration.5c80f4aa.webp";